import React from 'react';
import { Link } from "react-router-dom";
import '../assets/css/careers.css';

export default class About extends React.Component {
    render() {
        return (
            <div>

                <div className="about">
                    {/* <div className="hero">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-8">
                                    <div className="card full-card">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <h2 className="bold deep-blue-text">Core Values</h2>
                                                <p>
                                                    The FSDH brand represents professionalism integrity, good quality safety, reliability;
                                                    all for the benefit of our customers and stakeholders. These values are the driving force
                                                    behind the success of our business. We imbibe the values of honesty and discretion in our approach to work.
                                        </p><br />
                                                <NavLink to="/" className="gray-bordered-button-sm">Read more</NavLink>
                                            </div>
                                            <div className="col-md-4">
                                                <h2 className="bold deep-blue-text">Our Culture</h2>
                                                <p>Our corporate values and beliefs are at the core of what we do, and provide us with a framework of good conduct</p>
                                                <br />
                                                <NavLink to="/" className="gray-bordered-button-sm">Read more</NavLink>
                                            </div>
                                            <div className="col-md-4">
                                                <h2 className="bold deep-blue-text">Corporate Social Responsibility</h2>
                                                <p>
                                                    “Creating a strong business and building a better world are not conflicting goals;
                                                    they are both essential ingredients for long-term success”-Bill Ford. At FSDH,
                                                    we recognise the need to give back to our society to make it a better place, so we have
                                                    always had the act of corporate social responsibility at our core
                                        </p><br />
                                                <NavLink to="/" className="gray-bordered-button-sm">Read more</NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="card half-card white-text dark-blue-bg">
                                        <span>CAREERS</span>
                                        <div className="to-bottom">
                                            <p className="winning-team-heading">Join the <br />Winning Team</p>
                                            <br />
                                            <button className="white-button">
                                                Apply
                                    </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                     {/* white-text */}
                     <div className="body white-text"  style={{background: 'var(--fsdh-deep-blue)'}}>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-8">
                                    <h2 className="bold">Our Story</h2>
                                    <p></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="body ">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-7 col-xl-7">
                                    {/* <h2 className="bold">Our Story</h2> */}
                                    <p>
                                    First Securities Discount House Limited, the precursor to FSDH Merchant Bank Limited, was incorporated in June 1992 as the first discount house to operate in Nigeria. In the new era, FSDH Merchant Bank Limited was one of the first companies to be granted a merchant banking license in the country.
                                    </p>
                                    <p>
                                    Over the years, the FSDH Merchant Bank has become a financial services supermarket that delivers expert financial services within Nigeria and to select clientele, in order to create long term sustainable wealth.
                                    </p>
                                    <p>
                                    Our journey to becoming a merchant bank started when the Central Bank of Nigeria revoked all universal banking licenses in 2009 and created a new banking structure in the country. Under the new structure, banks are now categorised as commercial or merchant banks.
                                    </p>
                                    <p>
                                    Prior to the creation of the new structure by the CBN, FSDH had- through its subsidiaries- developed the structures required to offer the full range of merchant banking services (to the extent permitted by then regulation). However, with the new CBN structure in place, the people at FSDH regarded the change as an opportunity to expand the scope of our operations, while retaining focus on our core activities, in order to serve you better.
                                    </p>
                                    <p>
                                    In November 2012, the CBN granted our application and issued to us our Merchant Banking License.
                                    </p>
                                    <br />
                                </div>
                                <div className='d-sm-none d-md-block col-md-1 col-xl-2'></div>
                                <div className="col-md-4 col-xl-3">
                                    <div className="card black-text">
                                        <p className="bold">Mission</p>
                                        <hr />
                                        <p>
                                        Improving outcomes for our customers and subsidiaries while delivering value for our shareholders.
                                        </p><br />

                                        <p className="bold">Vision</p>
                                        <hr />
                                        <p>
                                        To be a top aggregator of financial assets in Nigeria
                                        </p><br />

                                        <p className="bold">Credit Rating</p>
                                        <hr />
                                        <p>The rating assigned to FSDH Merchant Bank Limited (‘FSDH’ or ‘the Bank’) is underpinned by good capitalization, good liquidity, good profitability and an experienced management team.<br /><br />
                                        <a href="/creditrating" className="gray-bordered-button-sm">Read more</a>
                                        </p><br />

                                        <p className="bold">Locations</p>
                                        <hr />
                                        <p>
                                        FSDH Merchant Bank provides a connection for our partners to services in Corporate and Investment Banking in Africa in these locations.<br /><br />
                                        <a href="/contact" className="gray-bordered-button-sm">Read more</a>
                                        </p><br />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='career-cont'>
                    <header className="preheader">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="card values">
                                        <div className="row">
                                            <div className="col-sm-4 col-md-4 val">
                                                <div className="info">
                                                    <h4 className="bold deep-blue-text">Our Group</h4>
                                                    <p>FSDH Holding Company Limited is a non-operating holding company focused on the provision of progressive financial services in Nigeria. The Company and its subsidiaries; FSDH Merchant Bank, FSDH Asset Management, FSDH Securities, and PAL Pensions, maintain a robust portfolio which enables the offerings of a diversified range of financial products and services across the country.</p>
                                                    <a href="/about" className="gray-bordered-button-sm">Read more</a>
                                                </div>
                                            </div>
                                            <div className="col-sm-4 col-md-4 val">
                                                <div className="info">
                                                    <h4 className="bold deep-blue-text">Our Leadership</h4>
                                                    <p>FSDH Merchant Bank has a strong team of financial experts that provide on hand advice to help inform your financial choices, while ensuring the final decision is always yours.</p>
                                                    <a href="/people" className="gray-bordered-button-sm">Read more</a>
                                                </div>
                                            </div>
                                            <div className="col-sm-4 col-md-4 val">
                                                <div className="info">
                                                    <h4 className="bold deep-blue-text">Our People</h4>
                                                    <p>Our employees are our most important assets. Their commitment, collaboration and engagement are essential to delivering true value and creating enduring wealth for our stakeholders.
                                                    </p>
                                                    <a href="/ourpeople" className="gray-bordered-button-sm">Read more</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="card full-card service-card burgundy-bg">
                                        <div className="column white-text">
                                            <span>CAREERS</span>
                                            <div className="card-body">
                                                <p className="block-heading">The FSDH Culture</p>

                                                <a href="/culture" className="white-button-sm">Read More</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </header>
                </div>

                    <div className="subsidiaries">
                        <div className="container-fluid">
                            <p className="bold big-para-text">Affiliates</p><br />
                            <div className="row">
                                <div className="col-md-3 col-sm-4">
                                    <p className="bold">FSDH Asset Management</p>
                                    <p>
                                        FSDH Asset Management Limited (FSDH AM) was established
                                        to provide investment advisory and portfolio management
                                        services to clients whose investment horizon.
                                    </p>
                                    <Link to=''>
                                        <span className="dark-blue-text">Visit Site</span>
                                    </Link>
                                </div>
                                <div className="col-md-3 col-sm-4">
                                    <p className="bold">FSDH Securities Limited</p>
                                    <p>
                                        FSDH Securities Limited (FSDH SEC) is a wholly owned
                                        subsidiary of FSDH Asset Management Limited which is
                                        also a subsidiary of FSDH Merchant Bank Limited.
                                    </p>
                                    <Link to=''>
                                        <span className="dark-blue-text">Visit Site</span>
                                    </Link>
                                </div>
                                <div className="col-md-3 col-sm-4">
                                    <p className="bold">Pensions Alliance Limited</p>
                                    <p>
                                        Pensions Alliance Limited is a joint venture between FSDH
                                        Merchant Bank Limited (FSDH MB) and African Alliance Insurance Company Limited.
                                    </p>
                                    <Link to=''>
                                        <span className="dark-blue-text">Visit Site</span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}